import Vue from 'vue';

Vue.component('svg-rndr', {
    props: {
        svg: {
            type: String
        },
        width: {
            type: Number,
            default: null
        },
        height: {
            type: Number,
            default: null
        },
        inline: {
            type: Boolean,
            default: false
        },
        ariaHidden: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            inner: '',
            attributes: {},
            svgWidth: null,
            svgHeight: null
        };
    },
    created() {
        let { type, svg } = this.getSvg();

        if (type == 'import') {
            svg.then(svg => {
                // Essentially stripping the SVG apart to avoid having an extra div
                // in the render method
                let temp = document.createRange().createContextualFragment(svg);
                let node = temp.childNodes[0];

                if (this.$browser.name == 'ie') {
                    let { width, height } = node.viewBox.baseVal;
                    node.style.cssText = `position: absolute;top: 0;left: 0;width: 100%;max-height: ${
                        this.height ? this.height : height
                    }px;`;
                    this.setWidth(width);
                    this.setHeight(height);
                } else {
                    this.setWidth();
                    this.setHeight();
                }
                this.attributesToObject(Array.from(node.attributes));
                let svgInner = Array.prototype.map
                    .call(node.childNodes, child =>
                        new XMLSerializer().serializeToString(child)
                    )
                    .join('');
                this.inner = svgInner;
            });
        } else if (type == 'slot') {
            if (this.$browser.name == 'ie') {
                let viewBox = svg.data.attrs.viewBox;
                let width = viewBox.split(' ')[2];
                let height = viewBox.split(' ')[3];

                svg.data.attrs.style = `position: absolute;top: 0;left: 0;width: 100%;max-height: ${
                    this.height ? this.height : height
                }px;`;

                this.setWidth(width);
                this.setHeight(height);
            } else {
                this.setWidth();
                this.setHeight();
            }
        }
    },
    methods: {
        setWidth(width = null) {
            if (this.width == null) {
                if (width) this.svgWidth = width;
            } else {
                this.svgWidth = this.width;
            }
        },
        setHeight(height) {
            if (this.height == null) {
                if (height) this.svgHeight = height;
            } else {
                this.svgHeight = this.height;
            }
        },
        getSvg() {
            // Prefers slotted SVG (less processing)
            if (this.$slots.default && this.$slots.default[0].tag == 'svg') {
                return { type: 'slot', svg: this.$slots.default[0] };
            } else {
                return {
                    type: 'import',
                    svg: import(/* webpackMode: "eager" */ `@svg/${this.svg}`)
                };
            }
        },
        // Converts attributes array to object
        attributesToObject(attributes) {
            let attrObj = {};
            attributes.forEach(attr => {
                attrObj[attr.name] = attr.value;
            });
            this.attributes = attrObj;
        }
    },
    computed: {
        canvasEl() {
            return h => {
                return this.$browser.name == 'ie'
                    ? h('canvas', {
                          attrs: {
                              style: `max-width: ${
                                  this.svgWidth
                              }px; max-height: ${
                                  this.svgHeight
                              }px; width: 100%; height: 100%;`
                          }
                      })
                    : null;
            };
        },
        svgImportedEl() {
            return h => {
                return this.svg
                    ? h('svg', {
                          attrs: this.attributes,
                          domProps: {
                              innerHTML: this.inner
                          }
                      })
                    : null;
            };
        },
        svgChildEl() {
            return h => {
                return this.$slots.default
                    ? h(
                          'svg',
                          this.$slots.default[0].data,
                          this.$slots.default[0].children
                      )
                    : null;
            };
        }
    },
    render: function(h) {
        let userAttrs =
            this.$browser.name != 'ie'
                ? {
                      width: this.svgWidth ? this.svgWidth + 'px' : '100%',
                      height: this.svgHeight ? this.svgHeight + 'px' : 'auto'
                  }
                : {};
        return h(
            'div',
            {
                attrs: {
                    class: 'svg-wrapper'
                },
                style: {
                    position: 'relative',
                    display: this.inline ? 'inline-block' : 'block',
                    width: this.svgWidth ? this.svgWidth + 'px' : '100%',
                    height: this.svgHeight ? this.svgHeight + 'px' : 'auto'
                }
            },
            [this.canvasEl(h), this.svgImportedEl(h), this.svgChildEl(h)]
        );
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/SVGRendererComponent.js